module.exports = __webpack_public_path__ + "static/media/colorBridging1.2f26dc4e.jpg";